import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getSupplierThunk = createAsyncThunk(
    `SupplierSlicer/getSupplierThunk`,
    async ({ term, includeNotCompleted = false, includeSupplierId = null }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const url = term
            ? `Supplier/search?term=${term}`
            : "Supplier/search"

        const config = {
            headers,
            params: {
                includeNotCompleted,
                includeSupplierId
            }
        };

        const { data } = await conciergeApiClient.get(url, config);

        return data;
    }
);

const initialState = {
    dataSupplier: [],
    loadingSupplier: false,
    errorSupplier: false,
};

const SupplierSlicer = createSlice({
    name: 'Supplier',
    initialState,
    reducers: {
        resetDataSupplier: (state) => {
            state.dataSupplier = [];
            state.loadingSupplier = false;
            state.errorSupplier = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getSupplierThunk.pending, (state) => {
            state.dataSupplier = [];
            state.loadingSupplier = true;
            state.errorSupplier = false;
        });
        builder.addCase(getSupplierThunk.fulfilled, (state, action) => {
            state.dataSupplier = action.payload;
            state.loadingSupplier = false;
            state.errorSupplier = false;
        });
        builder.addCase(getSupplierThunk.rejected, (state) => {
            state.dataSupplier = [];
            state.loadingSupplier = false;
            state.errorSupplier = true;
        });
    },
});

export const { resetDataSupplier } = SupplierSlicer.actions;
export default SupplierSlicer.reducer;